<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Carga de usuários por planilha
      </p>
    </div>

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-md bg-accent"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="usuario" label="Usuário" />
      <q-tab name="associar" label="Associar Perfil" />
      <q-tab name="desassociar" label="Desassociar Perfil" />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="usuario">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Usuário
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlide = !activeSlide"
            />
          </p>
        </div>

        <infot-upload
          :activeSlide="activeSlide"
          :infos="infos"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/controle-funcao/usuarios_r3.xlsx"
          :showUnidade="false"
        />

        <div class="row items-center q-mt-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="row items-center q-mt-sm">
          <div class="col-2">
            <q-file label="Selecione o Template" outlined dense v-model="file">
              <template v-slot:prepend>
                <q-icon name="attach_file" />
              </template>
            </q-file>
          </div>

          <div class="col-2">
            <q-btn
              color="positive"
              icon="add"
              no-caps
              class="q-ml-sm"
              label="Enviar Template"
              @click="enviarTemplate"
            />
          </div>
        </div>
      </q-tab-panel>

      <q-tab-panel name="associar">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Associar Perfil ao Usuário
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlideAssociar = !activeSlideAssociar"
            />
          </p>
        </div>

        <infot-upload
          :activeSlide="activeSlideAssociar"
          :infos="infosAssociar"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/controle-funcao/template-associar-perfil-usuario.xlsx"
          :showUnidade="false"
        />

        <div class="row items-center q-mt-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="row items-center q-mt-sm">
          <div class="col-2">
            <q-file
              label="Selecione o Template"
              outlined
              dense
              v-model="fileAssociar"
            >
              <template v-slot:prepend>
                <q-icon name="attach_file" />
              </template>
            </q-file>
          </div>

          <div class="col-2">
            <q-btn
              color="positive"
              icon="file_upload"
              no-caps
              class="q-ml-sm"
              label="Enviar Template"
              @click="enviarAssociarPerfil"
            />
          </div>
        </div>
      </q-tab-panel>

      <q-tab-panel name="desassociar">
        <div class="row col-12 q-mt-sm">
          <p class="text-h6 text-brand-5 text-weight-bold">
            Desassociar Perfil do Usuário
            <q-icon
              style="cursor: pointer"
              name="info"
              @click="activeSlideDesassociar = !activeSlideDesassociar"
            />
          </p>
        </div>

        <infot-upload
          :activeSlide="activeSlideDesassociar"
          :infos="infosDesassociar"
          link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/controle-funcao/template-desassociar-perfil-usuario.xlsx"
          :showUnidade="false"
        />

        <div class="row items-center q-mt-md">
          <div class="col-4">
            <lista-unidades-select />
          </div>
        </div>

        <div class="row items-center q-mt-sm">
          <div class="col-2">
            <q-file
              label="Selecione o Template"
              outlined
              dense
              v-model="fileDesassociar"
            >
              <template v-slot:prepend>
                <q-icon name="attach_file" />
              </template>
            </q-file>
          </div>

          <div class="col-2">
            <q-btn
              color="positive"
              icon="file_upload"
              no-caps
              class="q-ml-sm"
              label="Enviar Template"
              @click="enviarDesassociarPerfil"
            />
          </div>
        </div>
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import InfotUpload from "../../compras/components/InfotUpload.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { InfotUpload, ListaUnidadesSelect },
  setup() {
    const activeSlide = ref(false);
    const activeSlideAssociar = ref(false);
    const activeSlideDesassociar = ref(false);
    const quasar = useQuasar();
    const store = useStore();
    const file = ref("");
    const fileAssociar = ref("");
    const fileDesassociar = ref("");

    const infos = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais",
        icon: "delete",
      },
      {
        name: "O EMAIL não é atualizado por planilha, ele é somente criado em uma primeira execução",
        icon: "view_column",
      },
      {
        name: "O CENTRO DE CUSTO não é atualizado por esta planilha, ele é somente criado em uma primeira execução.",
        icon: "do_not_disturb",
      },
      {
        name: "Se houver erro de digitação da coluna B (ID ou username) outro usuário será criado, por exemplo, se for informado inicialmente o ID 1234 e posteriormente o ID 01234, o sistema criará outro usuário",
        icon: "event",
      },
      {
        name: "Se houver erro de digitação na coluna G (código centro de custo), o sistema criará um novo centro de custo e associará ao colaborador",
        icon: "event",
      },
      {
        name: "Se houver erro de digitação na coluna F (função ou ghe), o sistema criará outra função e associará ao colaborador",
        icon: "event",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "event",
      },
    ]);

    const infosAssociar = ref([
      {
        name: "O limite para vínculo é de 50 linhas por vez",
        icon: "format_list_numbered",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais",
        icon: "delete",
      },
      {
        name: "Essa planilha não cria usuários nem perfis, só realiza o vínculo",
        icon: "link",
      },
      {
        name: "Os dois campos do template são obrigatórios (matricula_usuario e nome_perfil)",
        icon: "check_circle",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const infosDesassociar = ref([
      {
        name: "O limite para vínculo é de 50 linhas por vez",
        icon: "format_list_numbered",
      },
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais",
        icon: "delete",
      },
      {
        name: "Essa planilha não cria usuários nem perfis, só realiza o vínculo",
        icon: "link",
      },
      {
        name: "O campo matricula_usuario é obrigatório",
        icon: "check_circle",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "schedule",
      },
    ]);

    const notificarErroArquivo = () => {
      quasar.notify({
        message: "O tipo do arquivo não é aceito, ou o campo está vazio",
        color: "negative",
        actions: [{ label: "Fechar", color: "white", handler: () => {} }],
      });
    };

    const enviarTemplate = async () => {
      if (file.value == "" || file.value.name.indexOf("xlsx") == -1) {
        notificarErroArquivo();
        return;
      }

      try {
        var reader = new FileReader();
        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          await store.dispatch("user/criarUsuarioTemplate", {
            planilha: reader.result,
            vendor: store.state.org.unidadeData.id,
          });
        };

        quasar.notify({
          message: "Usuario criado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });

        file.value = "";
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao criar Usuário",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        file.value = "";
      }
    };

    const enviarAssociarPerfil = async () => {
      if (
        fileAssociar.value == "" ||
        fileAssociar.value.name.indexOf("xlsx") == -1
      ) {
        notificarErroArquivo();
        return;
      }

      try {
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileAssociar.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        await store.dispatch("user/associarPerfilUsuarioPlanilha", {
          planilha: result,
          vendor: store.state.org.unidadeData.id,
        });

        quasar.notify({
          message: "Planilha enviada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });

        fileAssociar.value = "";
      } catch (error) {
        console.log(error);
        const mensagem =
          error?.response?.data?.message ||
          "Erro ao enviar planilha de associação de perfil";
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        fileAssociar.value = "";
      }
    };

    const enviarDesassociarPerfil = async () => {
      if (
        fileDesassociar.value == "" ||
        fileDesassociar.value.name.indexOf("xlsx") == -1
      ) {
        notificarErroArquivo();
        return;
      }

      try {
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(fileDesassociar.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        await store.dispatch("user/desassociarPerfilUsuarioPlanilha", {
          planilha: result,
          vendor: store.state.org.unidadeData.id,
        });

        quasar.notify({
          message: "Planilha enviada com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });

        fileDesassociar.value = "";
      } catch (error) {
        console.log(error);
        const mensagem =
          error?.response?.data?.message ||
          "Erro ao enviar planilha de desassociação de perfil";
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        fileDesassociar.value = "";
      }
    };

    return {
      enviarTemplate,
      enviarAssociarPerfil,
      enviarDesassociarPerfil,
      file,
      fileAssociar,
      fileDesassociar,
      activeSlide,
      activeSlideAssociar,
      activeSlideDesassociar,
      infos,
      infosAssociar,
      infosDesassociar,
      tab: ref("usuario"),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
